document.addEventListener('DOMContentLoaded', function () {
	const staffMembers = document.querySelectorAll('.staff .staff-grid .person');

	staffMembers.forEach(member => {
		member.setAttribute('style', `--expanded-height: ${member.querySelector('.classes').scrollHeight}px;`);
	})

	window.addEventListener('resize', () => {
		staffMembers.forEach(member => {
			member.setAttribute('style', `--expanded-height: ${member.querySelector('.classes').scrollHeight}px;`);
		})
	})
});
